<template>

  <div class='bto-sb-element'>
    <div
      class='bto-sb-element'
      v-if="hrIDs.length > 0"
    >
      <!-- <inline-message v-if="!matchSports.length" type="info" :message="t('Public.NoEventsAvailable')"/> -->
      <!-- <empty-state v-if="!matchSports.length" :message="t(emptyStateMessage)" :icon-class="emptyStateIcon" /> -->
      <widget-category-horse-racing :tournamentIds="hrIDs" />
    </div>
    <category-nav-component
       v-if="fixtureIds.length > 0 || selectedTab.idx === 3 || selectedTab.idx === 4"
      :tabs="filtercategoryNavTabs"
      :selectedTab="selectedTab.idx"
      @tabSelected="handleTabSelect"
    />
    <div
      class='bto-sb-element'
      v-if="fixtureIds.length > 0 && selectedTab.idx !== 3 && selectedTab.idx !== 4 && !matchesPrintData && selectedTab.idx !== 5"
    >
      <!-- <inline-message v-if="!matchSports.length" type="info" :message="t('Public.NoEventsAvailable')"/> -->
      <empty-state v-if="!matchSports.length" :message="emptyStateStatusMessage" :icon-class="emptyStateClass" />
      <category-sport-component
        v-for="(sport) in matchSports"
        :key="sport.id"
        :sport="sport"
        :tournamentIds="tournamentIds"
      />
    </div>
    <category-print-component
      v-if="matchesPrintData"
      :tournamentData="matchesPrintData"
    />
    <category-outrights-widget
      v-if="selectedTab.idx === 3 && !outrightsPrintData"
      outrightsType="tournament"
      :fixtureIds="fixtureIds"
    />
    <category-outrights-widget
      v-if="selectedTab.idx === 4 && !outrightsPrintData"
      outrightsType="category"
      :fixtureIds="fixtureIds"
    />
    <outrights-print-component
      v-if="outrightsPrintData"
      :tournamentData="outrightsPrintData"
    />
    <boosted-odd-widget 
      v-show="selectedTab.idx === 5"
      :showSportFilter="false"
      :displaySlider="false"
      :embedded="true"
      @showBoostedOdds="checkIfBoostedHaveOdds" />
  </div>
</template>

<script>
  import store from '../../../store';
  import CategoryNavComponent from './component-category-nav';
  import { TournamentMatchesRequestService } from './service-tournament-matches-request';
  import FullSportModel from '../../../models/full-sport-model';
  import CategorySportComponent from './component-category-sport';
  import CategoryPrintComponent from './component-category-print';
  import CategoryOutrightsWidget from '../category-outrights/widget-category-outrights';
  import OutrightsPrintComponent from '../category-outrights/component-outrights-print';

  import { EventBus } from '../../../services/event-bus-service';
  import DateFilterService from '../../../services/date-filter-service';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import WidgetCategoryHorseRacing from '../category-horse-racing/widget-category-horse-racing.vue';
  import BoostedOddWidget from '@bto-widgets/boosted-odd/src/web';


  export default {
    name: 'CategoryWidget',
    components: {
      CategoryNavComponent,
      CategorySportComponent,
      CategoryPrintComponent,
      CategoryOutrightsWidget,
      OutrightsPrintComponent,
      EmptyState,
      WidgetCategoryHorseRacing,
      BoostedOddWidget
    },
    data() {
      return {
        prevFixtureIds: [],
        fixtureIds: [],
        hrIDs: [],
        tournamentIds: [],
        prevTournamentIds: [],
        categoryNavTabs: [
          {
            type: 'text',
            value: this.t('W.AllM'),
          },
          {
            type: 'text',
            value: this.t('W.TodM'),
          },
          {
            type: 'select',
            value: [
              this.formatDate(1),
              this.formatDate(2),
              this.formatDate(3),
              this.formatDate(4),
            ],
          },
          {
            type: 'text',
            value: this.t('Mobile.Outrights'),
          },
          {
            type: 'text',
            value: null,
            specialTab: true, // ...
          },
          {
            type: 'text',
            value: this.t('BO.BoostedOdd'),
            key: 'boosted'
          },
        ],
        selectedTab: {
          idx: 0,
          option: null,
        },
        matchSports: [],
        matchesPrintData: undefined,
        outrightsPrintData: undefined,
        prevTimeFilter: false,
        emptyStateIcon: ICON_CLASS.MATCH_DETAILS,
        emptyStateMessage: 'Public.NoEventsAvailable',
        loading: false,
        loadingSpinner: ICON_CLASS.LOADING,
        showBoostedOdds: false,
      };
    },
    beforeRouteUpdate(to, from, next) {
      this.initTournaments(false, false, to.params.fixtureIds);
      next();
    },
    created() {
      store.commit('hideAfterRouteWidgets');
      this.initTournaments();

      EventBus.$on('openCategoryPrintPage', (data) => {
        this.matchesPrintData = data;
      });
      EventBus.$on('closeCategoryPrintPage', () => {
        this.matchesPrintData = undefined;
      });

      EventBus.$on('openOutrightsPrintPage', (data) => {
        this.outrightsPrintData = data;
      });

      EventBus.$on('closeOutrightsPrintPage', () => {
        this.outrightsPrintData = undefined;
      });

      EventBus.$on('updateTabCategoryName', (categoryName, categoryClass) => {
        this.categoryNavTabs = this.categoryNavTabs.map(tab => {
          if (tab.specialTab) {
            return {
              ...tab,
              value: `${categoryName} ${this.t('Mobile.Outrights')}`,
              class: categoryClass,
            };
          } else {
            return tab;
          }
        });
      });
    },
    computed: {
      emptyStateClass() {
        return this.loading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.loading ? this.t('Mobile.LoadingMore') : this.t(this.emptyStateMessage);
      },
      filtercategoryNavTabs() {
        return this.categoryNavTabs.filter((t) => {
          if(t.key && t.key === 'boosted' && !this.showBoostedOdds) {
            return false
          }
          return true;
        });
      }
    },
    methods: {
      /**
       * Get formated date x number of days from today
       * @param {number} idx - Number of days from today
      //  */
      formatDate(idx) {
        const locale = APP_SETTINGS.locale || APP_SETTINGS.player.language;
        let timestamp = new Date(new Date().setDate(new Date().getDate() + idx));
        if(locale === 'ja') {
          return timestamp.toLocaleString('ja', {year:'numeric',month:'short',day:'numeric'});
        }
        let date = timestamp.getDate() >= 10 ? timestamp.getDate() : `0${timestamp.getDate()}`;
        let month = timestamp.getMonth() + 1 >= 10 ? timestamp.getMonth() + 1 : `0${timestamp.getMonth() + 1}`;
        let year = timestamp.getFullYear();
        return `${date}.${month}.${year}`;
      },
      /**
       * Returns items that are present in array1 but not in array2
       * @param {any[]} array1
       * @param {any[]} array2
       */
      findDifference(array1, array2) {
        let result = [];
        array1.forEach(a1 => {
          if (!array2.includes(a1)) {
            result.push(a1);
          }
        });
        return result;
      },
      /**
       * @param {number|false} timeFilter - Time filter enum or false
       * @param {boolean} tabSelect - Flag wheather we changed tab or added/removed fixtures 
       * @param {string} [routeParams] - Optional fixture ids string from route params
       */
      initTournaments(timeFilter = false, tabSelect = false, routeParams = '') {
        // If we add/remove tournaments go to matches tab 
        if (!tabSelect) {
          this.selectedTab = { idx: 0, option: null };
        }
        // if we have time filter or had time filter reset to get fresh matches
        if (timeFilter || this.prevTimeFilter) {
          this.prevTournamentIds = [];
          this.matchSports = [];
        }

        /**
         * Logic for time filter we need this if we move from time filter tabs to tabs other than all matches tab
         */
        if (timeFilter) {
          this.prevTimeFilter = true;
        } else if (this.prevTimeFilter && this.selectedTab.idx === 0) {
          this.prevTimeFilter = false;
        }

        /**
         * Get fixtureIds from route
         */
        if (routeParams) {
          this.fixtureIds = routeParams.split(',').filter(fid => !fid.startsWith('hr') && !fid.startsWith('gh'));
        } else {
          this.fixtureIds = this.$route.params.fixtureIds !== '-' ? this.$route.params.fixtureIds.split(',').filter(fid => !fid.startsWith('hr') && !fid.startsWith('gh')) : [];
        }
        this.hrIDs = this.$route.params.fixtureIds !== '-' ? this.$route.params.fixtureIds.split(',').filter(fid => fid.startsWith('hr') || fid.startsWith('gh')) : [];
        /**
         * Category outrights logic start
         * Special logic when we add/remove category outrights
         */
        let newFixtureIds = this.findDifference(this.fixtureIds, this.prevFixtureIds);
        /**
         * Last added fixutreId is category outright
         */
        if (newFixtureIds.length && newFixtureIds[newFixtureIds.length - 1].startsWith('c')) {
          this.prevFixtureIds = this.fixtureIds;
          this.selectedTab = { idx: 4, option: null };
          return;
        }

        let removedFixtureIds = this.findDifference(this.prevFixtureIds, this.fixtureIds);
        /**
         * Last removed fixutreId is category outright
         */
        if (removedFixtureIds.length && removedFixtureIds[removedFixtureIds.length - 1].startsWith('c')) {
          this.prevFixtureIds = this.fixtureIds;
          this.categoryNavTabs = this.categoryNavTabs.map(tab => {
            if (tab.specialTab) {
              return {
                ...tab,
                value: undefined,
                class: undefined,
              };
            } else {
              return tab;
            }
          });
          // /**
          //  * Specail case when we had filtered tournamets prior to adding/removing category outright
          //  */
          const tids = this.fixtureIds.filter(id => !id.startsWith('c'));
          const newTournamentIds = this.findDifference(tids, this.prevTournamentIds);
          let tabIdx = (this.matchSports.length === 0 && newTournamentIds.length === 0) ? 3 : 0;
          // /**
          //  * On category outright removal try to go to matches tab, if no matches go to outright tab
          //  */
          this.selectedTab = { idx: tabIdx, option: null };
          // return;
        }
        /**
         * Category outrights logic end
         * Tournamet logic start
         */

        // find difference from previous request
        this.tournamentIds = this.fixtureIds.filter(id => !id.startsWith('c'));
        let removedTournamentIds = this.findDifference(this.prevTournamentIds, this.tournamentIds);
        let newTournamentIds = this.findDifference(this.tournamentIds, this.prevTournamentIds);

        if (!removedTournamentIds.length && !newTournamentIds.length) {
          return;
        } // else difference found

        this.prevTournamentIds = this.tournamentIds;
        let matchSports = JSON.parse(JSON.stringify(this.matchSports));

        // removed tournament ids detected
        if (removedTournamentIds.length) {
          const filteredMatchSports = matchSports.filter(ms => {
            ms.tabs = ms.tabs.filter(t => !removedTournamentIds.some(rId => rId.replace('tg', '') === `${t.id}`));
            return ms.tabs.length > 0;
          });
          matchSports = filteredMatchSports;
          this.matchSports = matchSports;
          /**
           * On removal of tournaments if we have no matches and no new tournaments try to go to outrights tab
           */
          if (matchSports.length === 0 && newTournamentIds.length === 0 && this.tournamentIds.length > 0) {
            this.selectedTab = { idx: 3, option: null };
          }
        }

        // new tournamnet ids detected
        if (newTournamentIds.length && this.selectedTab.idx !== 3) {
          this.loadNewTournaments(timeFilter, tabSelect, matchSports, newTournamentIds);
        }
      },
      /**
       * Handle change tab click
       * @param {{tabIdx:number,optionIdx?: number}} object
       */
      handleTabSelect(object) {
        this.matchesPrintData = undefined;
        this.outrightsPrintData = undefined;

        this.selectedTab = {
          idx: object.tabIdx,
          option: object.optionIdx !== undefined ? object.optionIdx : null,
        };

        let timeFilter = undefined;
        if (this.selectedTab.idx === 1) {
          timeFilter = 1;
        } else if (this.selectedTab.option !== null) {
          timeFilter = (this.selectedTab.option + 2) * 100;
        }

        /**
         * Need to call initTournamets if we have time filter so we can fetch filterd matches
         * or if we had filterd matches to get all matches
         */
        this.initTournaments(timeFilter || false, true);
      },
      /**
       * Fetch and load new tournaments
       * @param {number|false} timeFilter - Time filter enum or false
       * @param {boolean} tabSelect - Flag wheather we changed tab or added/removed fixtures
       * @param {FullSportModel[]} matchSports - Array of matches
       * @param {string[]} newTournamentIds - Array of torunametIds to fetch
       */
      loadNewTournaments(timeFilter = false, tabSelect = false, matchSports = [], newTournamentIds = []) {
        this.loading = true;
        let tournamentMatchesRequest = new TournamentMatchesRequestService();

        tournamentMatchesRequest.getParams.TournamentData = this.$route.name === 'seoTournamentGroup' ? [] : newTournamentIds.filter(i => !i.startsWith('tg'));
        tournamentMatchesRequest.getParams.TournamentGroupData = this.$route.name === 'seoTournamentGroup' ? newTournamentIds : newTournamentIds.filter(i => i.startsWith('tg')).map(i => i.replace('tg', ''));
        // tournamentMatchesRequest.getParams.CategoryData
        tournamentMatchesRequest.getParams.TimeFilter =
          timeFilter
          ||
          DateFilterService.parseDateFilter(this.$route.params.fixtureDateFilter)
          ||
          0;

        // send tournament matches request
        tournamentMatchesRequest.execute((response) => {
          /**
           * select outrights tab if no tournament matches are returned
           * and we haven't got any matches from previuos tournaments
           */
          if (!response.data || !response.data.length) {
            if (!tabSelect && matchSports.length === 0) {
              this.selectedTab = { idx: 3, option: null };
            }
          } else {
            // process new data
            response.data.forEach((s) => {
              let responseSport = new FullSportModel(s);

              // if sport already exists, insert tab
              let matchingSport = matchSports.find(s => s.id === responseSport.id);
              if (matchingSport) {
                responseSport.tabs.forEach(t => matchingSport.tabs.unshift(t));
              } else {
                matchSports.unshift(responseSport);
              }

              // append combi data to sport object
              matchSports.find(x => x.id == s.id).combiMainMarkets = store.state.SportsModule.sportCombos[s.id] || {};

            });

            // shift last selected sport to the top
            if (matchSports.length > 1) {
              let lastTournamentIdInRoute = this.tournamentIds[this.tournamentIds.length - 1].replace('tg', '');
              let lastSportIdx = matchSports.findIndex(s => s.tabs.find(t => t.id == lastTournamentIdInRoute));

              if (lastSportIdx !== 0 && lastSportIdx !== -1) {
                let lastSport = JSON.parse(JSON.stringify(matchSports[lastSportIdx]));
                matchSports.splice(lastSportIdx);
                matchSports.unshift(lastSport);
              }
            }

            this.matchSports = matchSports;
          }
        }, (error) => {
          console.error(error); // eslint-disable-line
        }).finally(() => {
          this.loading = false;
        });
      },
      checkIfBoostedHaveOdds(flag) {
        this.showBoostedOdds = flag;
      },
    }
  };
</script>
